export default __webpack_public_path__ + "static/media/gallery-3.38f3f83b.jpg";